import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../../context/AuthContext";
import { ENDPOINTS } from "../../../../config/api";

const UpdateContrato = () => {

  const { id } = useParams();
  const navigate = useNavigate();
  const { authFetch } = useContext(AuthContext);

  const [entidades, setEntidades] = useState([]);
  const [loading, setLoading] = useState(true);

  const [formData, setFormData] = useState({
    num_contrato: "",
    id_entidad: "",
    presupuesto: "",
    start_date: "",
    end_date: "",
    objeto: "",
    valor_contrato: "",
    state: 1,
    doc_contra_partida: null
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");


  const formatearMoneda = (valor) => {
  if (valor === null || valor === undefined || valor === "") {
    return "";
  }

  return new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(Number(valor));
};

  // =======================
  // CARGAR DATOS
  // =======================
  useEffect(() => {

    const loadData = async () => {
      try {

        const resContrato = await authFetch(`${ENDPOINTS.getContratoProyecto}?id_contrato=${id}`);
        const resEntidades = await authFetch(ENDPOINTS.getEntityActive);

        if (resContrato.success) {
          const c = resContrato.data;

          setFormData({
            num_contrato: c.num_contrato || "",
            id_entidad: c.id_entidad || "",
            presupuesto: c.presupuesto || "",
            start_date: c.start_date || "",
            end_date: c.end_date || "",
            objeto: c.objeto || "",
            valor_contrato: c.valor_contrato || "",
            state: c.state ?? 1,
            doc_contra_partida: null
          });
        }

        if (resEntidades.success && Array.isArray(resEntidades.entidades)) {
          setEntidades(resEntidades.entidades);
        } else {
          setEntidades([]);
        }

      } catch (err) {
        console.error(err);
        setError("Error cargando datos");
      }

      setLoading(false);
    };

    loadData();

  }, [id, authFetch]);

  // =======================
  // INPUTS
  // =======================
  const handleChange = (e) => {

    const { name, value, files } = e.target;

    if (name === "doc_contra_partida") {
      setFormData({
        ...formData,
        doc_contra_partida: files[0]
      });
      return;
    }

    // ============================
    // CAMPOS MONETARIOS
    // ============================
    if (name === "presupuesto" || name === "valor_contrato") {

      const valorLimpio = value.replace(/\D/g, "");

      setFormData({
        ...formData,
        [name]: valorLimpio
      });

      return;
    }

    setFormData({
      ...formData,
      [name]: value
    });
  };

  // =======================
  // SUBMIT
  // =======================
  const handleSubmit = async (e) => {

    e.preventDefault();
    setError("");
    setSuccess("");

    try {

      const form = new FormData();

      Object.keys(formData).forEach((key) => {
        if (formData[key] !== null) {
          form.append(key, formData[key]);
        }
      });

      form.append("id_contrato", id);

      const res = await authFetch(ENDPOINTS.updateContratoProyectos, {
        method: "POST",
        body: form
      });

      if (!res.success) {
        setError(res.message);
        return;
      }

      setSuccess("Contrato actualizado correctamente");

      setTimeout(() => {
        navigate("/session/mod_proyectos/contrato_proyectos/contrato");
      }, 1500);

    } catch (err) {
      console.error(err);
      setError("Error en el servidor");
    }
  };

  if (loading) return <p>Cargando contrato...</p>;

  return (
    <div className="container mt-4 p-4">

      {/* HEADER */}
      <div className="d-flex justify-content-between mb-4">
        <h3>Editar Contrato</h3>

        <button
          className="btn btn-outline-pink"
          onClick={() => navigate(-1)}
        >
          <i className="bi bi-arrow-left me-1"></i> Volver
        </button>
      </div>

      <form className="card p-4 shadow-sm" onSubmit={handleSubmit}>

        {error && <div className="alert alert-danger">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}

        {/* FILA 1 */}
        <div className="row">

          <div className="col-md-6 mb-3">
            <label>Número contrato *</label>
            <input
              type="text"
              name="num_contrato"
              className="form-control"
              value={formData.num_contrato}
              onChange={handleChange}
              disabled
            />
          </div>

          <div className="col-md-6 mb-3">
            <label>Entidad *</label>
            <select
              name="id_entidad"
              className="form-select"
              value={formData.id_entidad}
              onChange={handleChange}
            >
              <option value="" hidden>Selecciona...</option>

              {(entidades || []).map((e) => (
                <option key={e.id_entidad} value={e.id_entidad}>
                  {e.name}
                </option>
              ))}

            </select>
          </div>

        </div>

        {/* FILA 2 */}
        <div className="row">

          <div className="col-md-6 mb-3">
            <label>Presupuesto *</label>
            <input
              type="text"
              name="presupuesto"
              className="form-control"
              value={formatearMoneda(formData.presupuesto)}
              onChange={handleChange}
              inputMode="numeric"
              placeholder="$0"
            />
          </div>

          <div className="col-md-6 mb-3">
            <label>Valor contrato *</label>
              <input
                type="text"
                name="valor_contrato"
                className="form-control"
                value={formatearMoneda(formData.valor_contrato)}
                onChange={handleChange}
                inputMode="numeric"
                placeholder="$0"
              />
          </div>

        </div>

        {/* FILA 3 */}
        <div className="row">

          <div className="col-md-6 mb-3">
            <label>Fecha inicio *</label>
            <input
              type="date"
              name="start_date"
              className="form-control"
              value={formData.start_date}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label>Fecha fin *</label>
            <input
              type="date"
              name="end_date"
              className="form-control"
              value={formData.end_date}
              onChange={handleChange}
            />
          </div>

        </div>

        {/* OBJETO */}
        <div className="mb-3">
          <label>Objeto *</label>
          <textarea
            name="objeto"
            className="form-control"
            rows={3}
            value={formData.objeto}
            onChange={handleChange}
          />
        </div>

        {/* ESTADO */}
        <div className="mb-3">
          <label>Estado</label>
          <select
            name="state"
            className="form-select"
            value={formData.state}
            onChange={handleChange}
          >
            <option value={1}>Activo</option>
            <option value={0}>Inactivo</option>
          </select>
        </div>

        {/* ARCHIVO */}
        <div className="mb-3">
          <label>Reemplazar documento (opcional)</label>
          <input
            type="file"
            name="doc_contra_partida"
            className="form-control"
            accept=".pdf,.doc,.docx"
            onChange={handleChange}
          />
        </div>

        <button type="submit" className="btn btn-outline-pink w-100 mt-3">
          Actualizar contrato
        </button>

      </form>
    </div>
  );
};

export default UpdateContrato;